import React from 'react';
import * as PropTypes from 'prop-types';
import H1 from '../h1';
import H2 from '../h2';
import H3 from '../h3';
import H4 from '../h4';
import H5 from '../h5';
import H6 from '../h6';

const Title = ({ children, element, fontSize }) => (
  <>
    {element === 'h1' && <H1 fontSize={fontSize}>{children}</H1>}
    {element === 'h2' && <H2 fontSize={fontSize}>{children}</H2>}
    {element === 'h3' && <H3 fontSize={fontSize}>{children}</H3>}
    {element === 'h4' && <H4 fontSize={fontSize}>{children}</H4>}
    {element === 'h5' && <H5 fontSize={fontSize}>{children}</H5>}
    {element === 'h6' && <H6 fontSize={fontSize}>{children}</H6>}
  </>
);

Title.propTypes = {
  element: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  fontSize: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Title.defaultProps = {
  element: 'h1',
  fontSize: null,
};

export default Title;
